export default class {
	constructor(obj) {
		this.id = obj.id
		this.date = obj.date
		this.measure = obj.measure
		this.continuity = obj.continuity
		this.status = obj.status
		this.qualification = obj.qualification
		this.piezometerId = obj.piezometer_id
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoDetailPiezometerMeasure.js